/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snapshot_History_Not_Completed_StatusInputs */



/**
* | output |
* | --- |
* | "Not completed" |
*
* @param {Snapshot_History_Not_Completed_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snapshot_history_not_completed_status = /** @type {((inputs?: Snapshot_History_Not_Completed_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snapshot_History_Not_Completed_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Non termine")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nicht abgeschlossen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Non completato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не завершено")
	if (locale === "es") return /** @type {LocalizedString} */ ("No completado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未完成")
	if (locale === "ja") return /** @type {LocalizedString} */ ("未完了")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पूरा नहीं हुआ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não concluído")
	return /** @type {LocalizedString} */ ("Not completed")
});